import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Heart, Users, Award } from 'lucide-react';

const UeberUns = () => {
  return (
    <div className="page-container">
      <section className="page-hero">
        <div className="section-container">
          <h1 className="page-title">Über uns</h1>
          <p className="page-subtitle">
            Familienbetrieb mit Herz und Kompetenz
          </p>
        </div>
      </section>

      <section className="page-content">
        <div className="section-container">
          <div className="ueber-uns-intro">
            <img 
              src="https://customer-assets.emergentagent.com/job_physiograu/artifacts/50mmofh2_IMG_7217.JPG" 
              alt="Praxis Physiotherapie Grau"
              className="ueber-uns-image"
            />
            <div className="ueber-uns-text">
              <h2 className="subsection-title">Physiotherapie Grau</h2>
              <p className="text-content">
                Unsere Praxis ist ein Familienbetrieb, in dem persönliche Betreuung und 
                individuelle Behandlung im Mittelpunkt stehen. Der Name Grau steht für 
                Vertrauen, Erfahrung und familiäre Atmosphäre.
              </p>
              <p className="text-content">
                Mutter und Sohn führen gemeinsam die Praxis und bringen ihre jeweiligen 
                Kompetenzen und Erfahrungen ein, um Ihnen die bestmögliche Behandlung 
                zu bieten.
              </p>
            </div>
          </div>

          <div className="values-grid">
            <Card className="value-card">
              <CardContent className="value-card-content">
                <Heart className="value-icon" />
                <h3 className="value-title">Persönlich</h3>
                <p className="value-description">
                  Wir nehmen uns Zeit für Sie und behandeln jeden Patienten individuell 
                  nach seinen Bedürfnissen.
                </p>
              </CardContent>
            </Card>
            <Card className="value-card">
              <CardContent className="value-card-content">
                <Users className="value-icon" />
                <h3 className="value-title">Familiär</h3>
                <p className="value-description">
                  Als Familienbetrieb schaffen wir eine vertrauensvolle Atmosphäre, 
                  in der Sie sich wohlfühlen.
                </p>
              </CardContent>
            </Card>
            <Card className="value-card">
              <CardContent className="value-card-content">
                <Award className="value-icon" />
                <h3 className="value-title">Erfahren</h3>
                <p className="value-description">
                  Langjährige Erfahrung und kontinuierliche Weiterbildung garantieren 
                  hohe Behandlungsqualität.
                </p>
              </CardContent>
            </Card>
          </div>

          <div className="philosophy-section">
            <h2 className="subsection-title">Unsere Philosophie</h2>
            <div className="philosophy-content">
              <p className="text-content">
                In unserer Praxis arbeiten wir nach dem Grundsatz, dass jeder Patient 
                individuelle Bedürfnisse hat. Wir nehmen uns die Zeit, Sie kennenzulernen, 
                Ihre Beschwerden zu verstehen und einen auf Sie zugeschnittenen Behandlungsplan 
                zu erstellen.
              </p>
              <p className="text-content">
                Qualität steht für uns an erster Stelle. Das bedeutet: gründliche Befundung, 
                individuelle Behandlung und kontinuierliche Begleitung auf Ihrem Weg zur 
                Besserung.
              </p>
              <p className="text-content">
                Als kleiner Familienbetrieb können wir Ihnen die persönliche Aufmerksamkeit 
                geben, die in größeren Einrichtungen oft nicht möglich ist. Sie werden bei 
                uns nicht zur Nummer, sondern bleiben Mensch.
              </p>
            </div>
          </div>

          <div className="standort-section">
            <h2 className="subsection-title">Unser Standort</h2>
            <p className="text-content">
              Unsere Praxis befindet sich im Herzen von Apolda. Die zentrale Lage ermöglicht 
              eine gute Erreichbarkeit für Patienten aus Apolda und Umgebung.
            </p>
            <p className="text-content">
              Für Patienten, die den Weg zu uns nicht selbstständig bewältigen können, 
              bieten wir Hausbesuche an.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default UeberUns;